import { Volume } from "./selecao-volumes.model";

export type ObjGridVolCols = (keyof Volume | 'select' | 'medidas')[];

export interface ObjetoGridVolumes<Grid> {
  grid: Grid[];
  // usar DEF_VOL_COLS por padrão
  showCols?: ObjGridVolCols;
  opcaoSelecionada?: number;
  manifestoGerado?: boolean;
  disabledButtonFinalizar?: boolean;
  disabledButtonLiberar?: boolean;
  possuiFae?: boolean;
}

export const DEF_VOL_COLS: ObjGridVolCols = [
  'barCodeVol',
  'etiqueta',
  'etiqueta2',
  'medidas',
  'pesoPED',
  'pesoOriginal',
  'pesoCubado',
  'pesoCubadoOrig',
];

export const SHOW_ALL_VOL_COLS: ObjGridVolCols =
DEF_VOL_COLS.concat([
  'filialOrigem',
  'filialDestino',
  'numeroCompletoManifesto',
]);

export const SHOW_ALL_VOL_COLS_NAO_COMPLETAS: ObjGridVolCols =
DEF_VOL_COLS.concat([
  'filialOrigem',
  'filialDestino',
  'numeroCompletoManifesto',
  'containerUnique'
]);

export const RECEP_UNIT_COLS: ObjGridVolCols = [
  'pedEtiqueta',
  'dtRecepVol',
  'possuiIntervencao',
  'observacao',
  'estoqueRecusa'
];

export const SHOW_ALL_VOL_COLS_Vencimento: ObjGridVolCols =
DEF_VOL_COLS.concat([
  'filialOrigem',
  'filialDestino',
  'numeroCompletoManifesto',
  'dtEntregaPrevista'
]);
